import {
  useGetPlans,
  useGetProducts,
  useGetTaskingContracts,
} from '@api/products';

const convertPlans = plans =>
  (plans ?? []).map(plan => ({
    id: plan.id,
    productType: 'plan',
    title: plan.plan.name,
    startDate: plan.active_from,
    endDate: plan.active_to,
  }));

const convertProducts = products =>
  (products ?? []).map(product => ({
    id: product.id,
    productType: 'product',
    title: product.title,
    description: product.description,
    startDate: product.term_start_date,
    endDate: product.term_end_date,
  }));

const convertTaskingContracts = contracts =>
  (contracts ?? []).map(contract => ({
    id: contract.id,
    productType: 'tasking',
    title: contract.sfdc,
    startDate: contract.start_date,
    endDate: contract.expiration_date,
  }));

export const useDataProducts = ({orgId}) => {
  const planQuery = useGetPlans();
  const planProducts = convertPlans(planQuery.data ?? []);

  const productsQuery = useGetProducts();
  const products = convertProducts(productsQuery.data?.results ?? []);

  const taskingQuery = useGetTaskingContracts({orgId});
  const taskingProducts = convertTaskingContracts(
    taskingQuery.data?.results ?? [],
  );

  const allProducts = [...planProducts, ...products, ...taskingProducts].sort(
    // Sort alphabetically
    (a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0),
  );

  const error = planQuery.error || productsQuery.error || taskingQuery.error;
  const isLoading =
    planQuery.isLoading || productsQuery.isLoading || taskingQuery.isLoading;

  return {
    products: !isLoading && !error ? allProducts : [],
    error,
    isLoading,
  };
};

export default useDataProducts;
